export const useUserData = () => {
  const loading = ref(false);
  const error = ref<Error | null>(null);
  const errorsByType = reactive<Record<string, string | null>>({
    cart: null,
    quotes: null,
    buyingLists: null,
  });

  const load = async (options: {
    cart?: boolean;
    quotes?: boolean;
    buyingLists?: boolean;
  }) => {
    loading.value = true;
    error.value = null;
    errorsByType.cart = null;
    errorsByType.quotes = null;
    errorsByType.buyingLists = null;

    const promises: Promise<void>[] = [];

    if (options.cart) {
      promises.push(
        (async () => {
          try {
            await useCart().getCartOrCreate({
              currency: 'EUR',
              pageable: { page: 0, size: 10 },
              status: ['INIT', 'LOADING', 'ON_GOING'].join(','),
              type: ['CART'],
            }, true);
          } catch (err: any) {
            errorsByType.cart = err?.message || 'Erreur panier';
            console.error('[Cart]', err);
          }
        })()
      );
    }

    if (options.quotes) {
      promises.push(
        (async () => {
          try {
            await useQuote().getMasterQuotes({
              fromCustomerAccount: true,
              pageable: { page: 0, size: 999 },
            }, true);
          } catch (err: any) {
            errorsByType.quotes = err?.message || 'Erreur devis';
            console.error('[Quotes]', err);
          }
        })()
      );
    }

    if (options.buyingLists) {
      promises.push(
        (async () => {
          try {
            await useBuyingList().getBuyingLists({
              currency: 'EUR',
              pageable: { page: 0, size: 999 },
              status: ['INIT', 'LOADING', 'ON_GOING'].join(','),
              type: ['CART'],
            }, true);
          } catch (err: any) {
            errorsByType.buyingLists = err?.message || 'Erreur listes d’achat';
            console.error('[BuyingLists]', err);
          }
        })()
      );
    }

    await Promise.all(promises);
    loading.value = false;

    // Une erreur globale si au moins un des appels échoue
    if (Object.values(errorsByType).some(Boolean)) {
      error.value = new Error('Certaines données n’ont pas pu être chargées');
    }
  };

  return {
    loading,
    error,
    errorsByType,
    load,
  };
};